<nav class="cat__core__top-sidebar cat__core__top-sidebar--bg cat__core__top-sidebar--tabs">

  <span class="cat__core__title d-block mt-2 mb-2">
        <strong>FUNDRAISING TOOLBOX - TEAM CAPTAIN'S GUIDE</strong>
  </span>

</nav>

<div class="nav-tabs-horizontal tab-body">
  <ul ngbNav #tabSet="ngbNav" class="nav-link-inside nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink>5 Steps to Success</a>
      <ng-template ngbNavContent>
        <app-five-steps-team></app-five-steps-team>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink>Downloads</a>
      <ng-template ngbNavContent>
        <app-downloads-team></app-downloads-team>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="tabSet" class="mt-2"></div>
</div>
